import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import HeaderCategoryProxy from '../proxies/HeaderCategoryProxy'

class HeaderCategoryService extends ServiceBase {
  getHeaderActiveStatus(params) {
    return this.applyMemoryCache(
      'HeaderCategoryService.getHeaderActiveStatus',
      params,
    )(() => HeaderCategoryProxy.getHeaderActiveStatus(params))
  }

  getHeaderLocation(params) {
    return this.applyMemoryCache(
      'HeaderCategoryService.getHeaderLocation',
      params,
    )(() => HeaderCategoryProxy.getHeaderLocation(params))
  }
}

export default new HeaderCategoryService()
